module.exports = __webpack_public_path__ + "img/calendar.433eae69.svg";